<template>
    <div class="mt-2">
        <b-form-select
            v-model="option"
            :options="filterOptions.accountingFirmOffices"
            :disabled="!viewAllClients"
            size="sm"
            :class="selectClass"
            @change="setFilter"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'AccountingFirmCompanyOfficeSelect',

    mixins: [DataUpdater],
    props: {
        showAll: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    data() {
        return {
            option: 0,
        }
    },

    computed: {
        ...mapState({
            filters: (state) => state.reportingVM.filters,
            filterOptions: (state) => state.data.options,
            viewAllClients: (state) => state.reportingVM.viewAllClients,
        }),

        selectClass() {
            return this.option === 0 ? 'bg-white' : 'selected-filter'
        },
    },

    created() {
        this.option = this.filters.accountingFirmOffice
    },

    methods: {
        async setFilter() {
            await this.$store.dispatch(
                'reportingVM/setAccountingFirmOfficeFilter',
                this.option
            )
            this.$emit('office-has-changed')
            this.updateData()
            await this.$store.dispatch('reportingVM/refreshCounters')
        },
    },
}
</script>
